<div class="container-filter__padding">
  <div class="item-filter">
    <div class="lista">
      <span class="filter__title">Permissões</span>
      <div style="margin-top: 5px"></div>

      @for(grupo of gruposPermissoes; track $index) {
      <div class="item">
        <mat-checkbox
          color="primary"
          labelPosition="before"
          [(ngModel)]="grupo.ativo"
          (ngModelChange)="atualizafiltroPermissoes(grupo.id, $event)"
        >
          <div
            style="position: absolute; width: 90%; height: 50%; cursor: pointer"
          ></div>
          <span
            class="filter-text"
            style="cursor: pointer; white-space: nowrap"
            >{{ grupo.nome }}</span
          >
        </mat-checkbox>
      </div>
      }
    </div>
  </div>
</div>
